export const link = ({ theme }) => ({
    display: 'inline-block',
    marginRight: '1.85rem',
    marginTop: '0.5rem',
    min1200px: {
        marginRight: 0,
        marginLeft: '1.85rem',
    },
});
